import Vue from 'vue';
import Router from 'vue-router';

Vue.use(Router);

export default config =>
  new Router({
    base: window.location.pathname + '#',
    mode: 'abstract',
    routes: config
  });
